namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class ExpandToLevelEditor extends Serenity.Select2Editor<any, any> {

        constructor(hidden: JQuery) {
            super(hidden);

            this.addOption("0", "Collapse All");
            this.addOption("-1", "Expand All");
            this.addOption("1", "Level 1");
            this.addOption("2", "Level 2");
            this.addOption("3", "Level 3");
            this.addOption("4", "Level 4");
            this.addOption("5", "Level 5");
            this.addOption("6", "Level 6");
            this.addOption("7", "Level 7");
            this.addOption("8", "Level 8");
            this.addOption("9", "Level 9");
            this.addOption("10", "Level 10");

             $('<a class="inplace-button minus" style="float: left; margin-right: 2px;">' + 
                '<b><i class="fa fa-minus"></i></b></a>')
                .insertBefore(hidden.prev(".select2-container"))
                .click(() => {
                    if (this.value == "0")
                        return;

                    var value;
                    if (!this.value)
                        value = "0";
                    else if (this.value == "-1")
                        value = this.items.length - 2;
                    else
                        value = (parseInt(this.value) - 1).toString();
                    this.element.select2('val', value).triggerHandler('change');
                });

            $('<a class="inplace-button plus" style="float: left; margin-right: 6px">' + 
                '<b><i class="fa fa-plus"></i></b></a>')
                .insertAfter(hidden)
                .click(() => {
                    if (this.value == "-1")
                        return;

                    var value;
                    if (!this.value)
                        value = 1;
                    else if (this.value == (this.items.length - 2).toString())
                        value = "-1";
                    else
                        value = (parseInt(this.value) + 1).toString();
                    this.element.select2('val', value).triggerHandler('change');
                });
           
        }

        protected emptyItemText() {
            return "--expand to--";
        }

        private _modelCode;

        get modelCode(): string {
            return this._modelCode;
        }

        set modelCode(value: string) {
            if (this._modelCode != value) {
                var model = value ? ModelRow.getLookup().itemById[value] : null;

                var oldValue = this.value;
                this.clearItems();
                this.addOption("0", "Collapse All");
                this.addOption("-1", "Expand All");
                var levels = model == null ? 10 : (model.Levels || 10);
                for (var l = 1; l <= levels; l++) {
                    this.addOption(l.toString(), model == null ? ("Level " + l) : (model["LevelName" + l] || ("Level " + l)));
                }
                this.value = null;
                this.value = oldValue;
            }
        }
    }
}